import { useTu } from "@src/appV2/i18n/useTu";
import { type SxProps, type Theme } from "@mui/material";
import { mergeSxProps } from "@src/appV2/lib";
import { useIsMobile } from "../../AppLayout/useResponsive";
import { Text } from "../Text";
import { HamburgerIcon } from "./HamburgerIcon";
import { FloatingNavigationItemWrapper } from "./ItemWrapper";

export interface FloatingNavigationOpenMenuButtonProps {
  /**
   * Callback when the button is clicked
   */
  onClick?: () => void;
  /**
   * Additional styles
   */
  sx?: SxProps<Theme>;
}

/**
 * Floating navigation button that appears in the bottom right corner on mobile.
 * Only renders on mobile viewports.
 */
export function FloatingNavigationOpenMenuButton(props: FloatingNavigationOpenMenuButtonProps) {
  const { tu } = useTu("common");

  const { onClick, sx } = props;
  const isMobile = useIsMobile();

  if (!isMobile) {
    return null;
  }

  return (
    <FloatingNavigationItemWrapper
      sx={mergeSxProps(
        (theme: Theme) => ({
          right: theme.size?.floatingNavigation.margin,
          gap: 2,
          paddingX: 4,
          paddingY: 3,
          width: "auto",
          height: "auto",
          borderRadius: "100px",
        }),
        sx
      )}
      onClick={onClick}
    >
      <HamburgerIcon />
      <Text semibold variant="body1" sx={{ color: "inherit", letterSpacing: "0.02em" }}>
        {tu("Menu")}
      </Text>
    </FloatingNavigationItemWrapper>
  );
}
